export enum UserRoles {
    TDL_VNB_USER = 'TNB_TDL_rolle_vnbnutzer',
    TDL_ADMIN_USER = 'TNB_TDL_rolle_wnadmin',
    TDL_WESTNETZ_USER = 'TNB_TDL_rolle_wnnutzer',
}
